// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

// Your web app's Firebase configuration
export const firebaseConfig = {
  apiKey: "AIzaSyCQSYTunu_wj1xY5AS9KxzoTnpn2Ygmu7k",
  authDomain: "kierepbase.firebaseapp.com",
  projectId: "kierepbase",
  storageBucket: "kierepbase.firebasestorage.app",
  messagingSenderId: "127908691138",
  appId: "1:127908691138:web:32702d52a8357635b2cf5b",
  measurementId: "G-8HMJVZHRK8"
};

// Initialize Firebase App
const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);